import { lazyForPaint } from 'react-loosely-lazy';
export const LazyOverviewTabV2 = lazyForPaint(() => import(/* webpackPrefetch: true, webpackChunkName: "chunk-overview-tab-v2" */'./v2').then(module => module.OverviewTab));